import { type ComponentProps, useRef } from 'react';

import { Command as CommandPrimitive } from 'cmdk';
import { Link } from 'react-router';

import { COMMAND_ITEM_CLASS_NAME } from '@/components/ui/command';
import { cn } from '@/lib/utils';

export const CommandLinkItem = ({
  className,
  href,
  children,
  onSelect,
  ...props
}: ComponentProps<typeof CommandPrimitive.Item> & { href: string }) => {
  const openedInNewTab = useRef(false);

  const handleSelect = (value: string) => {
    if (openedInNewTab.current) {
      openedInNewTab.current = false;
      return;
    }
    onSelect?.(value);
  };

  return (
    <CommandPrimitive.Item asChild {...props} onSelect={onSelect ? handleSelect : undefined}>
      <Link
        to={href}
        data-slot="command-item"
        className={cn(COMMAND_ITEM_CLASS_NAME, className)}
        onClick={(e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) {
            openedInNewTab.current = true;
            return;
          }
          openedInNewTab.current = false;
          if (onSelect) {
            e.preventDefault();
          }
        }}
      >
        {children}
      </Link>
    </CommandPrimitive.Item>
  );
};
